import { SUPPLIER_BASELINES } from '../supplyChainBaselines';

const OEM_SUPPLIER_IDS_BY_MANUFACTURER: Readonly<Record<string, readonly string[]>> = {
  'Ansaldo Energia': ['supplier-ansaldo-energia'],
  'Baker Hughes': ['supplier-baker-hughes-power'],
  'Bergen Engines': ['supplier-bergen-engines'],
  'Capstone Energy': ['supplier-capstone-energy'],
  Caterpillar: ['supplier-caterpillar-power'],
  Cummins: ['supplier-cummins-power'],
  Everllence: ['supplier-man-energy'],
  'GE Vernova': ['supplier-ge-vernova'],
  'Guascor Energy': ['supplier-siemens-guascor'],
  'INNIO Jenbacher': ['supplier-innio-jenbacher'],
  'Kawasaki Heavy Industries': ['supplier-kawasaki-energy'],
  'Leroy-Somer / Nidec Power': ['supplier-leroy-somer-nidec'],
  'Mitsubishi Power': ['supplier-mitsubishi-power'],
  MWM: ['supplier-mwm'],
  Rehlko: ['supplier-kohler-power'],
  'Rolls-Royce mtu': ['supplier-rolls-royce-mtu'],
  'Siemens Energy': ['supplier-siemens-energy'],
  'Solar Turbines': ['supplier-solar-turbines'],
  'STAMFORD | AvK': ['supplier-stamford-avk'],
  Wärtsilä: ['supplier-wartsila-power'],
  Generac: ['supplier-generac-industrial'],
};

export function supplierIdsForOemManufacturer(manufacturer: string): readonly string[] {
  return OEM_SUPPLIER_IDS_BY_MANUFACTURER[manufacturer] ?? [];
}

export function validateOemSupplierLinks(
  manufacturers: readonly string[],
): readonly string[] {
  const errors: string[] = [];
  const supplierIds = new Set(SUPPLIER_BASELINES.map(supplier => supplier.id));
  for (const manufacturer of new Set(manufacturers)) {
    const linked = supplierIdsForOemManufacturer(manufacturer);
    if (linked.length === 0) {
      errors.push(`${manufacturer} has no OEM supplier mapping`);
      continue;
    }
    for (const supplierId of linked) {
      if (!supplierIds.has(supplierId)) {
        errors.push(`${manufacturer} maps to unknown supplier ${supplierId}`);
      }
    }
  }
  return errors;
}
